import React from 'react';

import { AnimacaoNaoEncontrado } from 'Component/Animacao';
import BotaoLink from 'Component/BotaoLink';

interface Props {
    carregando: boolean;
    registros?: number;
    redirecionar?: string;
}

const SemRegistros = ({ carregando, registros = 0, redirecionar }: Props): React.ReactElement =>
{
    return (
        <React.Fragment>
            { !carregando && !registros && (
                <div className="animate__animated animate__fadeIn d-flex flex-column flex-grow-1 justify-content-center align-items-center">
                    <AnimacaoNaoEncontrado />
                    <p className="h1">
                        Nenhum registro encontrado
                    </p>
                    { redirecionar && (
                        <React.Fragment>
                            <p className="lead">
                                Clique no botão abaixo para adicionar um novo registro!
                            </p>
                            <BotaoLink
                                tema="success"
                                icone="plus-lg"
                                to={ redirecionar }
                            >
                                Adicionar
                            </BotaoLink>
                        </React.Fragment>
                    ) }
                </div>
            ) }
        </React.Fragment>
    )
}

export default SemRegistros;
